import { Router } from '@reach/router';

import { PageProps } from 'gatsby';
import {
  AdminOverview,
  AdminProposalsOverview,
  AdminReferralsOverview,
  AdminUsers,
  AdminUsersOverview,
  useAdminRedirects,
} from 'modules/admin';
import { useProposalSubscription } from 'modules/proposals';
import { useSettingsSubscription } from 'modules/settings';
import React from 'react';

const AdminPage: React.FC<PageProps> = (props) => {
  useSettingsSubscription();
  useAdminRedirects();
  useProposalSubscription();

  return (
    <Router basepath="/admin">
      <AdminUsers {...props} path="/users" />
      <AdminOverview {...props} path="/overview" />
      <AdminUsersOverview {...props} path="/users-overview" />
      <AdminReferralsOverview {...props} path="/referrals-overview" />
      <AdminProposalsOverview {...props} path="/proposals-overview" />
    </Router>
  );
};

export default AdminPage;
